import React from "react";
import { Outlet } from "react-router-dom";

const PhysicianRoutes: React.FC = () => {
  // Route protection temporarily removed
  return <Outlet />;
};

export default PhysicianRoutes;